export default "https://static.homerun-beta.co/images/play-circle.svg?5594a1e3fafada399e9c239cccedba05";